<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="#">
              Discoveria
            </a>
          </li>
          <li>
            <a :href="rulesUrl" target="_blank">
              Regulamin
            </a>
          </li>
          <li>
            <a :href="policyUrl" target="_blank">
              Polityka prywatności
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://zbudujplan.pl/" target="_blank">Discoveria</a>
        developed by Yellows Software House
      </div>
    </div>
  </footer>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      rulesUrl: state => state.rulesDocUrl,
      policyUrl: state => state.policyDocUrl,
    }),
  },
}
</script>
<style></style>
